module.exports = __webpack_public_path__ + "static/media/chevron_ouvre.1333a73b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chevron_ouvre.svg
// module id = 53
// module chunks = 0